import "./App.css";
import "./bootstrap.min.css";
import Dream from "./Dream";
function App() {
  return (
    <div className="App" style={{ textAlign: "center", marginTop: "0px" }}>
      <h1
        style={{
          textAlign: "center",
          color: "var(--red)",
          fontFamily: "Alata, sans-serif",
          marginTop: "23px",
        }}
      >
        <strong>Soi Đề Online</strong>
      </h1>
      <hr />
      <Dream/>
    </div>
  );
}

export default App;
